import { Injectable } from '@angular/core';

import { BaseCommentService } from '../comments';

@Injectable({
  providedIn: 'root',
})
export abstract class TmsWebBaseCommentService extends BaseCommentService {
  protected constructor(baseRoute: string) {
    super(baseRoute);
  }

  protected get apiUrl() {
    return `TmsWeb/${this.baseRoute}`;
  }
}
